import * as React from 'react'
import { AnchorLink } from './link-components'

type Props = {
  variant?: 'primary' | 'secondary' | 'white' | 'newsecondary'
  fontSize?: string
  href: string
  onClick?: (e: any) => void
  children: any,
  className?: string
  target?:string
  style?:any
}
export default function Link({
  variant = 'primary',
  fontSize,
  href,
  onClick,
  children,
  className,
  target,
  style,
}: Props) {
  return (
    <AnchorLink
      className={className}
      variant={variant}
      fontSize={fontSize}
      to={href}
      style={style}
      target={target}
      onClick={onClick}>
      {children}
    </AnchorLink>
  )
}
